import { autoPlacement, autoUpdate, useClick, useDismiss, useFloating, useInteractions, useRole } from '@floating-ui/react';
export const getAutoPlacement = (placement) => {
    if (placement === 'auto') {
        return { autoPlacement: autoPlacement() };
    }
    if (placement === 'auto-start') {
        return { autoPlacement: autoPlacement({ alignment: 'start' }) };
    }
    if (placement === 'auto-end') {
        return { autoPlacement: autoPlacement({ alignment: 'end' }) };
    }
    return { placement };
};
export function usePopper(options) {
    const { refs, floatingStyles, context } = useFloating({ whileElementsMounted: autoUpdate, ...options });
    const click = useClick(context);
    const dismiss = useDismiss(context);
    const role = useRole(context);
    // Merge all the interactions into prop getters
    const { getReferenceProps, getFloatingProps } = useInteractions([click, dismiss, role]);
    return { refs, floatingStyles, getReferenceProps, getFloatingProps };
}
//# sourceMappingURL=usePopper.js.map